import React, { useEffect } from "react";
import { useParams, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import InterviewHostAgent from "./InterviewHostAgent";
import JobsRoles from "./InterviewHostAgent/JobsRoles";
import Candidates from "./InterviewHostAgent/Candidates";
import InterviewReport from "./InterviewHostAgent/InterviewReport";
import PageLoader from "../../components/PageLoader";

const AgentPage: React.FC = () => {
  const { agentFrameworkName } = useParams<{ agentFrameworkName: string }>();

  const currentAgent = useSelector(
    (state: RootState) => state.agents.currentAgent,
  );
  const agentsLoading = useSelector(
    (state: RootState) => state.agents.currentAgentLoading,
  );
  const agentError = useSelector(
    (state: RootState) => state.agents.currentAgentError,
  );

  // Debug logging
  useEffect(() => {
    console.log("AgentPage - agentFrameworkName:", agentFrameworkName);
    console.log("AgentPage - currentAgent:", currentAgent);
    console.log("AgentPage - agentsLoading:", agentsLoading);
    console.log("AgentPage - agentError:", agentError);
  }, [agentFrameworkName, currentAgent, agentsLoading, agentError]);

  // Let RequireAgentAccess handle loading and access control
  if (agentsLoading) {
    return <PageLoader label="Loading agent..." activeNav="home" />;
  }

  if (!currentAgent) {
    return <PageLoader label="Loading agent..." activeNav="home" />;
  }

  // Route to specific agent screens based on framework name
  // Handle both hyphenated and underscore versions for flexibility
  if (
    agentFrameworkName === "interview-host-agent" ||
    agentFrameworkName === "interview_host_agent"
  ) {
    return (
      <Routes>
        <Route index element={<InterviewHostAgent />} />
        <Route path="jobs" element={<JobsRoles />} />
        <Route path="jobs/:jobId/candidates" element={<Candidates />} />
        <Route path="jobs/:jobId/candidates/:candidateId/report" element={<InterviewReport />} />
      </Routes>
    );
  }

  // If we reach here with an unknown agent framework name, show a fallback
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Agent page not configured</h2>
      <p>The screen for "{agentFrameworkName}" is not yet implemented.</p>
    </div>
  );
};

export default AgentPage;
